const stopPunctualityReport = {
    namespaced: true,
    state: {
        stopPunctualityReportList: []
    },
    mutations: {
        updateStopPunctualityReportList(state, newList) {
            state.stopPunctualityReportList = newList;
        }
    },
    actions: {
        getStopPunctualityReport(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/stoppunctualityreport/getStopPunctualityReport', { params: data })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateStopPunctualityReportList', response.data);
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        getStopPassings(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/stoppunctualityreport/getStopPassings', { params: data })
                    .then(response => {
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        exportXLS(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/stoppunctualityreport/exportXLS', { params: data, responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/xlsx' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = 'stop_punctuality_report.xlsx'
                        link.click()
                        URL.revokeObjectURL(link.href)

                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        }
    }
}
export default stopPunctualityReport;